import * as React from 'react';
import PropTypes from 'prop-types';


const DefaultIcon = ({
    height = '32',
    width = '32',
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
        <path
            d="M4.14029 4.12784H9.70225L16 27.1115H10.4505L4.14029 4.12784ZM22.3102 4.12784H27.8722L21.5744 27.1115H16.0125L22.3102 4.12784Z"
            fill="white"
        />
    </svg>
);

DefaultIcon.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
};
export default DefaultIcon;
